export interface RootState {
    isLoading: boolean | null;
    isLoadingDetailStat: boolean | null;
}

export interface SelectItem {
    text: string
    value: string | number
}

export enum MsgTransports {
    SMS='SMS',
    CALL='Call',
    EMAIL='Email',
    PUSH='Push',
    USSD='USSD',
    VIBER = 'Viber',
    WHATSAPP = 'WhatsApp',
    MAILNOTIFY = 'Mail Notify',
    CUSTOM = 'Custom',
}

export const getTransportIdByName: Map<MsgTransports, number> = new Map([
  [MsgTransports.SMS, 1],
  [MsgTransports.CALL, 2],
  [MsgTransports.EMAIL, 3],
  [MsgTransports.PUSH, 4],
  [MsgTransports.USSD, 5],
  [MsgTransports.VIBER, 6],
  [MsgTransports.WHATSAPP, 7],
  [MsgTransports.CUSTOM, 8],
  [MsgTransports.MAILNOTIFY, 9],
])

export const getTransportNameById: Map<number, MsgTransports> = new Map([
    [1, MsgTransports.SMS],
    [2, MsgTransports.CALL],
    [3, MsgTransports.EMAIL],
    [4, MsgTransports.PUSH],
    [5, MsgTransports.USSD],
    [6, MsgTransports.VIBER],
    [7, MsgTransports.WHATSAPP],
    [8, MsgTransports.CUSTOM],
    [9, MsgTransports.MAILNOTIFY],
])
